import flattenMessages from '../flattenMessages';
import en from './en.json';
import es from './es.json';
import ru from './ru.json';
import zh from './zh.json';

export default {
  en: flattenMessages(en, 'ethereum'),
  es: flattenMessages(es, 'ethereum'),
  ru: flattenMessages(ru, 'ethereum'),
  zh: flattenMessages(zh, 'ethereum'),
};
